"use strict";

(function () {
  var sideCartSectionId = null;

  function resolveSideCartSectionId() {
    if (sideCartSectionId) {
      return sideCartSectionId;
    }

    var section = document.querySelector(".side-cart-section.shopify-section[id^='shopify-section-']");

    if (section && section.id) {
      sideCartSectionId = section.id.replace("shopify-section-", "");
      return sideCartSectionId;
    }

    sideCartSectionId = "side-cart";
    return sideCartSectionId;
  }

  function getCartSectionTargets() {
    return [
      { node: ".side-cart-inner", section: resolveSideCartSectionId(), selector: ".side-cart-inner" },
      { section: "cart-count" },
    ];
  }

  function getSideCartSectionHtml(sectionsHtml) {
    if (!sectionsHtml) {
      return null;
    }

    var sectionId = resolveSideCartSectionId();

    if (sectionsHtml[sectionId]) {
      return sectionsHtml[sectionId];
    }

    if (sectionsHtml["side-cart"]) {
      return sectionsHtml["side-cart"];
    }

    var keys = Object.keys(sectionsHtml);

    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf("side-cart") !== -1) {
        return sectionsHtml[keys[i]];
      }
    }

    return null;
  }

  function rewriteSideCartSectionValue(value) {
    var sectionId = resolveSideCartSectionId();

    if (sectionId === "side-cart" || value == null) {
      return value;
    }

    if (Array.isArray(value)) {
      return value.map(function (entry) {
        return entry === "side-cart" ? sectionId : entry;
      });
    }

    var stringValue = String(value);

    if (stringValue === "side-cart") {
      return sectionId;
    }

    if (stringValue.indexOf("side-cart") !== -1) {
      return stringValue
        .split(",")
        .map(function (entry) {
          return entry.trim() === "side-cart" ? sectionId : entry.trim();
        })
        .join(",");
    }

    return value;
  }

  function rewriteCartRequestSections(body) {
    if (!body || resolveSideCartSectionId() === "side-cart") {
      return body;
    }

    if (typeof body === "string") {
      try {
        var payload = JSON.parse(body);

        if (payload.sections) {
          payload.sections = rewriteSideCartSectionValue(payload.sections);
          return JSON.stringify(payload);
        }
      } catch (error) {}

      return body;
    }

    if (body instanceof FormData) {
      var nextForm = new FormData();

      body.forEach(function (value, key) {
        if (key === "sections" || key.indexOf("sections") === 0) {
          nextForm.append(key, rewriteSideCartSectionValue(value));
          return;
        }

        nextForm.append(key, value);
      });

      return nextForm;
    }

    return body;
  }

  function captureSideCartBenefitsHtml() {
    var footerBottom = document.querySelector(".side-cart-footer-bottom");

    if (!footerBottom) {
      return "";
    }

    var parts = [];

    footerBottom.querySelectorAll(".pdp-store-benefits").forEach(function (element) {
      parts.push(element.outerHTML);
    });

    return parts.join("");
  }

  function restoreSideCartBenefitsHtml(benefitsHtml) {
    if (!benefitsHtml) {
      return;
    }

    var footerBottom = document.querySelector(".side-cart .side-cart-footer-bottom");

    if (!footerBottom || footerBottom.querySelector(".pdp-store-benefits")) {
      return;
    }

    footerBottom.insertAdjacentHTML("beforeend", benefitsHtml);
  }

  var upsellInitTimer = null;
  var lastUpsellCartSignature = null;
  var upsellCartBusy = false;

  function setLoadingBar(active) {
    var bar = document.querySelector(".loading-bar");
    if (!bar) {
      return;
    }

    if (active) {
      bar.classList.add("active");
      bar.style.transform = "scaleX(0.7)";
      return;
    }

    bar.style.transform = "scaleX(1)";
    window.setTimeout(function () {
      bar.classList.remove("active");
      bar.style.transform = "scaleX(0)";
    }, 250);
  }

  function setUpsellButtonsLoading(isLoading) {
    document.querySelectorAll(".upsell-add-to-cart, .product-popup-atc").forEach(function (button) {
      if (isLoading) {
        button.classList.add("loading");
        button.setAttribute("aria-busy", "true");

        if ("disabled" in button) {
          button.disabled = true;
        } else {
          button.setAttribute("aria-disabled", "true");
        }
      } else {
        button.classList.remove("loading");
        button.removeAttribute("aria-busy");

        if ("disabled" in button) {
          button.disabled = false;
        } else {
          button.removeAttribute("aria-disabled");
        }
      }
    });

    document.querySelectorAll(".cart-upsell-products-wrapper").forEach(function (wrapper) {
      wrapper.classList.toggle("is-updating", isLoading);
    });
  }

  function beginUpsellCartAction() {
    upsellCartBusy = true;
    setUpsellButtonsLoading(true);
    setLoadingBar(true);
  }

  function endUpsellCartAction() {
    upsellCartBusy = false;
    setUpsellButtonsLoading(false);
    setLoadingBar(false);
  }

  function getSiblingWithClass(element, className) {
    if (element.classList.contains(className)) {
      return element;
    }

    var sibling = element.nextElementSibling;

    while (sibling) {
      if (sibling.classList.contains(className)) {
        return sibling;
      }
      sibling = sibling.nextElementSibling;
    }

    sibling = element.previousElementSibling;

    while (sibling) {
      if (sibling.classList.contains(className)) {
        return sibling;
      }
      sibling = sibling.previousElementSibling;
    }

    return null;
  }

  function findVariant(variants, selectedOptions) {
    return variants.find(function (variant) {
      return (
        variant.option1 == selectedOptions[0] &&
        variant.option2 == selectedOptions[1] &&
        variant.option3 == selectedOptions[2]
      );
    });
  }

  function updateSoldOutStates(container, variants, selectedOptions) {
    var optionContainers = container.querySelectorAll(".variant-field, .swatch-container");

    optionContainers.forEach(function (optionContainer, index) {
      var inputs = optionContainer.querySelectorAll(".field-value");
      var swatches = optionContainer.querySelectorAll(".swatch[data-value], .field-label[data-value]");

      if (inputs.length) {
        inputs.forEach(function (input) {
          var value = input.value;
          var currentSelectedOptions = selectedOptions.slice();
          currentSelectedOptions[index] = value;

          var matchingVariant = findVariant(variants, currentSelectedOptions);
          var label = optionContainer.querySelector('label[for="' + input.id + '"]');

          if (matchingVariant && !matchingVariant.available) {
            input.disabled = true;
            if (label) {
              label.classList.add("soldout_variant");
            }
          } else {
            input.disabled = false;
            if (label) {
              label.classList.remove("soldout_variant");
            }
          }
        });
        return;
      }

      swatches.forEach(function (swatch) {
        var value = swatch.getAttribute("data-value");
        var currentSelectedOptions = selectedOptions.slice();
        currentSelectedOptions[index] = value;

        var matchingVariant = findVariant(variants, currentSelectedOptions);

        if (matchingVariant && !matchingVariant.available) {
          swatch.classList.add("soldout_variant");
        } else {
          swatch.classList.remove("soldout_variant");
        }
      });
    });
  }

  function initializeUpsellSlider() {
    if (window.cart_upsell_display !== "horizontally") {
      return;
    }

    document.querySelectorAll(".cart-upsell-products-wrapper mivo-slider.cart-upsell-slider").forEach(function (slider) {
      if (slider.classList.contains("initialized")) {
        return;
      }

      if (typeof customElements !== "undefined" && typeof customElements.upgrade === "function") {
        customElements.upgrade(slider);
      }
    });

    showUpsellWrapper();
  }

  function showUpsellWrapper() {
    document.querySelectorAll(".cart-upsell-products-wrapper").forEach(function (wrapper) {
      wrapper.classList.add("is-visible");

      if (window.cart_upsell_display !== "horizontally") {
        return;
      }

      var slider = wrapper.querySelector(".cart-upsell-slider");
      if (slider && !slider.classList.contains("initialized") && typeof customElements !== "undefined" && typeof customElements.upgrade === "function") {
        customElements.upgrade(slider);
      }
    });
  }

  function resetSideCartLayout() {
    var sideCartInner = document.querySelector(".side-cart-inner");
    if (!sideCartInner) {
      return;
    }

    sideCartInner.scrollTop = 0;

    var sideCartContent = sideCartInner.querySelector(".side-cart-content");
    if (sideCartContent) {
      sideCartContent.scrollTop = 0;
    }

    var sideCartFooter = sideCartInner.querySelector(".side-cart-footer");
    if (sideCartFooter) {
      sideCartFooter.scrollTop = 0;
    }
  }

  function rebindSideCartUi() {
    var sideCart = document.querySelector(".side-cart");
    if (!sideCart) {
      return;
    }

    if (typeof btySideCart === "function") {
      btySideCart();
    }

    var closeButton = sideCart.querySelector(".side-cart-close");
    if (closeButton) {
      closeButton.onclick = function (event) {
        event.preventDefault();
        document.documentElement.classList.remove("side-cart-open");
        document.dispatchEvent(new CustomEvent("theme-popup-close"));

        if (sideCart.triggerElement) {
          sideCart.triggerElement.focus();
        }
      };
    }

    if (document.documentElement.classList.contains("side-cart-open") && closeButton && typeof btyTrapFocus === "function") {
      btyTrapFocus(sideCart, closeButton);
    }
  }

  function syncSideCartFromSection(sectionsHtml) {
    var sectionHtml = getSideCartSectionHtml(sectionsHtml);

    if (!sectionHtml || typeof btyGetSectionHtml !== "function") {
      return false;
    }

    var sideCartInner = document.querySelector(".side-cart-inner");
    if (!sideCartInner) {
      return false;
    }

    var html = btyGetSectionHtml(sectionHtml, ".side-cart-inner");
    if (!html) {
      return false;
    }

    var benefitsHtml = captureSideCartBenefitsHtml();

    sideCartInner.innerHTML = html;
    restoreSideCartBenefitsHtml(benefitsHtml);
    return true;
  }

  function reinitSideCart() {
    var sideCart = document.querySelector(".side-cart-inner");

    resetSideCartLayout();
    rebindSideCartUi();

    if (typeof btySideCartPopupOuter === "function") {
      btySideCartPopupOuter();
    }

    if (typeof btyAgreeToTerms === "function") {
      btyAgreeToTerms();
    }

    if (typeof btyQuantityButton === "function") {
      btyQuantityButton();
    }

    if (typeof btyUpdateProductQuantity === "function") {
      btyUpdateProductQuantity();
    }

    if (typeof btyAddToCart === "function" && sideCart) {
      btyAddToCart(sideCart);
    }

    runUpsellInitImmediate();

    window.requestAnimationFrame(function () {
      resetSideCartLayout();
      runUpsellInitImmediate();
    });

    window.setTimeout(function () {
      resetSideCartLayout();
      runUpsellInitImmediate();

      if (typeof window.reservationTimer === "function") {
        window.reservationTimer();
      }
    }, 100);
  }

  function scheduleUpsellInit(immediate) {
    clearTimeout(upsellInitTimer);

    if (immediate) {
      runUpsellInitImmediate();
      return;
    }

    upsellInitTimer = setTimeout(runUpsellInitImmediate, 300);
  }

  function runUpsellInitImmediate() {
    try {
      initializeUpsellSlider();
      showUpsellWrapper();
      initializeUpsellPopupVariants();
    } catch (error) {}
  }

  function getCartAddUrl() {
    if (window.btyGlobals && window.btyGlobals.cart_add_url) {
      return window.btyGlobals.cart_add_url.replace(/\/cart\/add\/?$/, "/cart/add.js");
    }

    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    return root + "cart/add.js";
  }

  function getCartJsonUrl() {
    if (window.btyGlobals && window.btyGlobals.cart_url) {
      return window.btyGlobals.cart_url + ".js";
    }

    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    return root + "cart.js";
  }

  function refreshSideCart(openCart) {
    var cartSectionTargets = getCartSectionTargets();
    var sectionIds = cartSectionTargets
      .map(function (target) {
        return target.section;
      })
      .filter(function (section, index, list) {
        return list.indexOf(section) === index;
      });

    var sectionsUrl = window.location.pathname + "?sections=" + sectionIds.join(",");

    return Promise.all([
      fetch(sectionsUrl).then(function (response) {
        return response.json();
      }),
      fetch(getCartJsonUrl()).then(function (response) {
        return response.json();
      }),
    ]).then(function (results) {
      var sectionsHtml = results[0];
      var cart = results[1];

      if (typeof btyUpdateHtml === "function") {
        btyUpdateHtml(sectionsHtml, cartSectionTargets);
      } else if (syncSideCartFromSection(sectionsHtml)) {
        reinitSideCart();
      }

      if (typeof btySideCartPopupOuter === "function") {
        btySideCartPopupOuter();
      }

      if (typeof btyCartItemCount === "function" && typeof btyGetSectionHtml === "function") {
        btyCartItemCount(btyGetSectionHtml(sectionsHtml["cart-count"], ".shopify-section"));
      }

      if (typeof btyUpdateProgressBarCart === "function") {
        btyUpdateProgressBarCart(cart.total_price);
      }

      if (typeof btyQuantityButton === "function") {
        btyQuantityButton();
      }

      if (typeof btyUpdateProductQuantity === "function") {
        btyUpdateProductQuantity();
      }

      if (typeof btyAgreeToTerms === "function") {
        btyAgreeToTerms();
      }

      if (openCart) {
        document.documentElement.classList.add("side-cart-open");
      }

      lastUpsellCartSignature = getUpsellCartSignature(cart);
    });
  }

  function normalizeSectionsHtml(sectionsHtml) {
    if (!sectionsHtml) {
      return sectionsHtml;
    }

    var sideCartHtml = getSideCartSectionHtml(sectionsHtml);

    if (!sideCartHtml || sectionsHtml["side-cart"]) {
      return sectionsHtml;
    }

    var normalizedSections = Object.assign({}, sectionsHtml);
    normalizedSections["side-cart"] = sideCartHtml;
    return normalizedSections;
  }

  function normalizeCartSectionsPayload(payload) {
    if (!payload || !payload.sections) {
      return payload;
    }

    payload.sections = normalizeSectionsHtml(payload.sections);
    return payload;
  }

  function patchCartResponseJson(response, url) {
    if (!response || typeof response.json !== "function") {
      return response;
    }

    var originalJson = response.json.bind(response);

    response.json = function () {
      return originalJson().then(function (payload) {
        normalizeCartSectionsPayload(payload);

        if (url.indexOf("/cart/change") !== -1 && payload && !payload.item_count) {
          lastUpsellCartSignature = "empty";
          removeCartUpsell();
        }

        return payload;
      });
    };

    return response;
  }

  function getUpsellCartSignature(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return "empty";
    }

    return cart.items
      .map(function (item) {
        return String(item.product_id);
      })
      .sort()
      .join(",");
  }

  function getCartSignatureFromDom() {
    var parts = [];

    document.querySelectorAll(".side-cart-content .product-item .product-name a[href]").forEach(function (link) {
      parts.push(link.getAttribute("href") || "");
    });

    return parts.sort().join("|") || "empty";
  }

  function isFullSideCartInnerUpdate(targets) {
    if (!targets || !targets.length) {
      return false;
    }

    return targets.some(function (target) {
      return target.node === ".side-cart-inner";
    });
  }

  function removeCartUpsell() {
    hideUpsellPopup();

    document.querySelectorAll(".cart-upsell-products-wrapper, .side-cart-inner > .upsell-product-popup_wrapper").forEach(function (element) {
      element.remove();
    });
  }

  function insertCartUpsellNodes(sideCartInner, upsellHtml, popupHtml) {
    if (upsellHtml) {
      var footer = sideCartInner.querySelector(".side-cart-footer");
      var upsellTemplate = document.createElement("template");
      upsellTemplate.innerHTML = upsellHtml.trim();
      var upsellNode = upsellTemplate.content.firstElementChild;

      if (upsellNode) {
        if (footer) {
          footer.before(upsellNode);
        } else {
          sideCartInner.appendChild(upsellNode);
        }
      }
    }

    if (popupHtml) {
      var popupTemplate = document.createElement("template");
      popupTemplate.innerHTML = popupHtml.trim();
      var popupNode = popupTemplate.content.firstElementChild;

      if (popupNode) {
        sideCartInner.appendChild(popupNode);
      }
    }
  }

  function updateCartUpsellFromSection(sectionHtml) {
    if (typeof btyGetSectionHtml !== "function") {
      return;
    }

    var sideCartContent = document.querySelector(".side-cart-content");
    var sideCartInner = document.querySelector(".side-cart-inner");

    if (!sideCartContent || !sideCartInner) {
      return;
    }

    if (sideCartContent.querySelector(".cart-empty")) {
      lastUpsellCartSignature = "empty";
      removeCartUpsell();
      return;
    }

    hideUpsellPopup();

    document.querySelectorAll(".cart-upsell-products-wrapper, .side-cart-inner > .upsell-product-popup_wrapper").forEach(function (element) {
      element.remove();
    });

    var upsellHtml = btyGetSectionHtml(sectionHtml, ".cart-upsell-products-wrapper", "outer");
    var popupHtml = btyGetSectionHtml(sectionHtml, ".upsell-product-popup_wrapper", "outer");

    insertCartUpsellNodes(sideCartInner, upsellHtml, popupHtml);
    lastUpsellCartSignature = getCartSignatureFromDom();
    runUpsellInitImmediate();
  }

  function patchThemeCartUpdates() {
    if (typeof btyUpdateHtml !== "function" || btyUpdateHtml.__upsellPatched) {
      return typeof btyUpdateHtml === "function";
    }

    var originalUpdateHtml = btyUpdateHtml;

    window.btyUpdateHtml = function (sectionsHtml, targets) {
      if (getSideCartSectionHtml(sectionsHtml) && syncSideCartFromSection(sectionsHtml)) {
        var sideCartId = resolveSideCartSectionId();
        var otherTargets = (targets || []).filter(function (target) {
          return target.section !== "side-cart" && target.section !== sideCartId;
        });

        if (otherTargets.length) {
          originalUpdateHtml(sectionsHtml, otherTargets);
        }

        lastUpsellCartSignature = getCartSignatureFromDom();
        reinitSideCart();
        return;
      }

      originalUpdateHtml(normalizeSectionsHtml(sectionsHtml), targets);
    };

    btyUpdateHtml.__upsellPatched = true;
    return true;
  }

  function patchCartChangeFetch() {
    if (window.fetch.__upsellCartPatched) {
      return;
    }

    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url ? input.url : "";
      var nextInit = init;

      if (
        init &&
        init.body &&
        (url.indexOf("/cart/add") !== -1 || url.indexOf("/cart/change") !== -1 || url.indexOf("/cart/update") !== -1)
      ) {
        nextInit = Object.assign({}, init, {
          body: rewriteCartRequestSections(init.body),
        });
      }

      return nativeFetch.call(this, input, nextInit).then(function (response) {
        if (!response || !response.ok) {
          return response;
        }

        if (
          url.indexOf("/cart/add") !== -1 ||
          url.indexOf("/cart/change") !== -1 ||
          url.indexOf("/cart/update") !== -1
        ) {
          return patchCartResponseJson(response, url);
        }

        return response;
      });
    };

    window.fetch.__upsellCartPatched = true;
  }

  function ensureThemeCartPatches() {
    patchCartChangeFetch();

    if (patchThemeCartUpdates()) {
      return;
    }

    var attempts = 0;
    var patchTimer = window.setInterval(function () {
      attempts += 1;

      if (patchThemeCartUpdates() || attempts >= 20) {
        window.clearInterval(patchTimer);
      }
    }, 50);
  }

  function addUpsellToCart(variantId, openCart) {
    beginUpsellCartAction();

    return fetch(getCartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
          },
        ],
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        if (payload && payload.status) {
          throw payload;
        }

        return refreshSideCart(openCart);
      })
      .finally(function () {
        endUpsellCartAction();
      });
  }

  function hideUpsellPopup() {
    document.querySelectorAll(".upsell-product-popup").forEach(function (popup) {
      popup.classList.remove("is-open");
      popup.hidden = true;
    });

    var wrapper = document.querySelector(".side-cart-inner > .upsell-product-popup_wrapper");
    if (wrapper) {
      wrapper.classList.remove("is-open");
      wrapper.hidden = true;
    }
  }

  function initializeUpsellPopupVariants(root) {
    (root || document).querySelectorAll(".upsell-product-popup .product-container").forEach(function (container) {
      var variants = JSON.parse(container.getAttribute("data-variants"));
      var selectedOptions = [];

      container.querySelectorAll(".variant-field, .swatch-container").forEach(function (optionContainer) {
        var checkedInput = optionContainer.querySelector(".field-value:checked");
        if (checkedInput) {
          selectedOptions.push(checkedInput.value);
        }
      });

      updateSoldOutStates(container, variants, selectedOptions);
    });
  }

  function showUpsellPopup(productId) {
    hideUpsellPopup();

    var wrapper = document.querySelector(".side-cart-inner > .upsell-product-popup_wrapper");
    var popup = document.querySelector('.upsell-product-popup[data-product-id="' + productId + '"]');

    if (!wrapper || !popup) {
      return;
    }

    wrapper.hidden = false;
    popup.hidden = false;
    wrapper.classList.add("is-open");
    popup.classList.add("is-open");
    initializeUpsellPopupVariants(popup);
  }

  function handleUpsellVariantChange(container) {
    if (!container) {
      return;
    }

    var variants = JSON.parse(container.getAttribute("data-variants"));
    var selectedOptions = [];

    container.querySelectorAll(".variant-field, .swatch-container").forEach(function (optionContainer) {
      var checkedInput = optionContainer.querySelector(".field-value:checked");
      var activeSwatch = optionContainer.querySelector(".swatch.active, .field-label.active");

      if (checkedInput) {
        selectedOptions.push(checkedInput.value);
      } else if (activeSwatch) {
        selectedOptions.push(activeSwatch.getAttribute("data-value"));
      }
    });

    var selectedVariant = findVariant(variants, selectedOptions);

    if (!selectedVariant) {
      return;
    }

    container.setAttribute("data-variant-selected", selectedVariant.id);
    updateSoldOutStates(container, variants, selectedOptions);

    var popupInner = container.closest(".upsell-popup-inner");
    var addButton = popupInner
      ? popupInner.querySelector(".product-popup-atc")
      : container.parentNode
        ? container.parentNode.querySelector(".product-popup-atc")
        : null;

    if (addButton) {
      addButton.setAttribute("data-vid", selectedVariant.id);
    }
  }

  function handleSwatchClick(swatch) {
    var container = swatch.closest(".product-container");
    if (!container) {
      return;
    }

    var siblings = Array.from(swatch.parentNode.children).filter(function (child) {
      return child !== swatch && child.classList.contains("swatch");
    });

    siblings.forEach(function (sibling) {
      sibling.classList.remove("active");
    });
    swatch.classList.add("active");

    handleUpsellVariantChange(container);
  }

  function bindEvents() {
    document.addEventListener("click", function (event) {
      var addButton = event.target.closest(".upsell-add-to-cart");
      if (addButton) {
        event.preventDefault();

        if (upsellCartBusy) {
          return;
        }

        var productId = addButton.getAttribute("data-product-id");
        var openPopup = (addButton.getAttribute("data-open-popup") || "").trim();

        if (openPopup === "yes") {
          showUpsellPopup(productId);
          return;
        }

        var variantId = addButton.getAttribute("data-vid");
        if (!variantId) {
          return;
        }

        addUpsellToCart(variantId, false).catch(function (error) {
          console.error(error);
        });
        return;
      }

      var popupAddButton = event.target.closest(".product-popup-atc");
      if (popupAddButton) {
        event.preventDefault();

        if (upsellCartBusy) {
          return;
        }

        var popupVariantId = popupAddButton.getAttribute("data-vid");
        if (!popupVariantId) {
          return;
        }

        addUpsellToCart(popupVariantId, true)
          .then(function () {
            hideUpsellPopup();
          })
          .catch(function (error) {
            console.error(error);
          });
        return;
      }

      var popupWrapper = event.target.closest(".upsell-product-popup_wrapper");
      if (popupWrapper && event.target === popupWrapper) {
        hideUpsellPopup();
        return;
      }

      var swatch = event.target.closest(".upsell-product-popup .swatch:not(.field-label)");
      if (swatch) {
        handleSwatchClick(swatch);
        return;
      }
    });

    document.addEventListener("change", function (event) {
      if (!event.target.matches(".upsell-product-popup .field-value")) {
        return;
      }

      handleUpsellVariantChange(event.target.closest(".product-container"));
    });

    initializeUpsellPopupVariants();
  }

  function observeSideCart() {
    var sideCartInner = document.querySelector(".side-cart-inner");
    if (!sideCartInner || typeof MutationObserver === "undefined") {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var upsellAdded = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          if (node.nodeType !== 1) {
            return false;
          }

          return (
            (node.classList && node.classList.contains("cart-upsell-products-wrapper")) ||
            (node.querySelector && node.querySelector(".cart-upsell-products-wrapper"))
          );
        });
      });

      if (upsellAdded) {
        runUpsellInitImmediate();
      }
    });

    observer.observe(sideCartInner, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    if (window.cart_upsell_display === "vertically") {
      document.documentElement.classList.add("cart-upsell-vertical");
    }

    ensureThemeCartPatches();
    bindEvents();
    observeSideCart();
    scheduleUpsellInit(true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// Start: Cart reservation timer
(function () {
  var storageKey = "cartReservationEndsAt";
  var timerSelector = ".reservation-text-timer";
  var originalSelector = ".cart-reservation-label-original";
  var timeSelector = ".reservation-text-timer .time";
  var intervalId = null;

  function getDurationInMinutes() {
    var duration = parseInt(window.reservation_label_text_timer_time, 10);
    return Number.isFinite(duration) && duration > 0 ? duration : 0;
  }

  function getEndsAt() {
    try {
      return parseInt(localStorage.getItem(storageKey), 10);
    } catch (error) {
      return NaN;
    }
  }

  function setEndsAt(value) {
    try {
      localStorage.setItem(storageKey, String(value));
    } catch (error) {}
  }

  function removeEndsAt() {
    try {
      localStorage.removeItem(storageKey);
    } catch (error) {}
  }

  function setReservationState(timerActive) {
    if (document.body) {
      document.body.classList.toggle("reservation-timer-active", timerActive);
      document.body.classList.toggle("hide-reservation-text-timer", !timerActive);
    }

    document.querySelectorAll(timerSelector).forEach(function (reservationTextTimer) {
      reservationTextTimer.style.display = timerActive ? "" : "none";
    });

    document.querySelectorAll(originalSelector).forEach(function (originalLabel) {
      originalLabel.style.display = timerActive ? "none" : "";
    });
  }

  function updateTimerDisplay() {
    var endsAt = getEndsAt();

    if (!endsAt || Number.isNaN(endsAt)) {
      setReservationState(false);
      return false;
    }

    var remainingTime = endsAt - Date.now();

    if (remainingTime <= 0) {
      removeEndsAt();
      setReservationState(false);
      return false;
    }

    var minutes = Math.floor(remainingTime / (1000 * 60));
    var seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    var display = minutes + ":" + seconds.toString().padStart(2, "0");

    document.querySelectorAll(timeSelector).forEach(function (time) {
      time.textContent = display;
    });

    setReservationState(true);
    return true;
  }

  function reservationTimer(options) {
    options = options || {};
    var duration = getDurationInMinutes();

    if (!duration) {
      setReservationState(false);
      return;
    }

    var endsAt = getEndsAt();

    if (options.reset) {
      setEndsAt(Date.now() + duration * 60 * 1000 + 1000);
    } else if (!endsAt || Number.isNaN(endsAt) || endsAt <= Date.now()) {
      removeEndsAt();
      setReservationState(false);
      return;
    }

    if (intervalId) {
      clearInterval(intervalId);
    }

    if (updateTimerDisplay()) {
      intervalId = setInterval(function () {
        if (!updateTimerDisplay()) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }, 1000);
    }
  }

  function checkCart() {
    var endsAt = getEndsAt();

    if (!endsAt || Number.isNaN(endsAt) || endsAt <= Date.now()) {
      reservationTimer({ reset: true });
    }
  }

  function scheduleReservationTimer(delay) {
    delay = typeof delay === "number" ? delay : 0;
    setTimeout(function () {
      reservationTimer();
    }, delay);
  }

  function handleCartUpdate(cart, options) {
    options = options || {};

    if (!cart || cart.item_count <= 0) {
      removeEndsAt();
      setReservationState(false);
      return;
    }

    if (options.reset) {
      checkCart();
      return;
    }

    scheduleReservationTimer(options.isAdd ? 60 : 1350);
  }

  function patchCartFetchForReservation() {
    if (window.fetch.__reservationTimerPatched) {
      return;
    }

    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      return nativeFetch.apply(this, arguments).then(function (response) {
        if (!response || !response.ok) {
          return response;
        }

        var url = typeof input === "string" ? input : input && input.url ? input.url : "";
        var isCartAdd = url.indexOf("/cart/add") !== -1;
        var isCartChange = url.indexOf("/cart/change") !== -1;
        var isCartUpdate = url.indexOf("/cart/update") !== -1;

        if (!isCartAdd && !isCartChange && !isCartUpdate) {
          return response;
        }

        return response
          .clone()
          .json()
          .then(function (payload) {
            if (payload) {
              if (isCartAdd && !payload.status) {
                handleCartUpdate({ item_count: 1 }, { reset: true, isAdd: true });
              } else if (typeof payload.item_count !== "undefined") {
                handleCartUpdate(payload, { isAdd: isCartAdd });
              }
            }

            return response;
          })
          .catch(function () {
            return response;
          });
      });
    };

    window.fetch.__reservationTimerPatched = true;
  }

  window.reservationTimer = reservationTimer;
  window.checkCart = checkCart;

  patchCartFetchForReservation();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      reservationTimer();
    });
  } else {
    reservationTimer();
  }

  document.addEventListener(
    "submit",
    function (event) {
      if (event.target && event.target.matches('[data-type="add-to-cart-form"]')) {
        checkCart();
      }
    },
    true
  );

  document.addEventListener("shopify:section:load", function () {
    scheduleReservationTimer(60);
  });
})();
// End: Cart reservation timer
